import { BaseRule } from "../BaseRule";

class RequiredRule extends BaseRule {

	required: boolean = true;
	allowEmptyStrings: boolean;

	constructor( errorMessage: string = 'Обязательное поле', allowEmptyStrings: boolean = false ) {
		super( "required", errorMessage );
		if ( !errorMessage ) {
			this.errorMessage = 'Обязательное поле';
		}
		this.allowEmptyStrings = allowEmptyStrings;
	};

	isValidInternal = ( val: string ) => {
		let testVal;
		const required = this.required;
		if ( val === undefined || val === null ) {
			return !required;
		}

		testVal = val;
		if ( typeof (val) === 'string' ) {
			if ( this.allowEmptyStrings ) {
				return true;
			}
			testVal = val.trim();
		}

		if ( !required ) { // if they passed: { required: false }, then don't require this
			return true;
		}

		return testVal.length > 0;
	};

};

export default RequiredRule;
